module.exports = __webpack_public_path__ + "static/media/correct.ea044017.png";